import { QUERY_KEYS } from '../../../../consts';
import { checkUserService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const checkUserAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER.CHECK_USER,
  mutationFn: () => checkUserService,
});
